var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewImmigrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.24C0 1.89831 1.89831 0 4.24 0H25.467C27.8087 0 29.707 1.89831 29.707 4.24V29.6143H0V4.24Z",
    fill: "#C384E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8538 23.7417C19.4411 23.7417 23.1597 20.0231 23.1597 15.4358C23.1597 10.8484 19.4411 7.12988 14.8538 7.12988C10.2664 7.12988 6.54785 10.8484 6.54785 15.4358C6.54785 20.0231 10.2664 23.7417 14.8538 23.7417Z",
    stroke: "white",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54785 14.1233C7.80011 13.5322 8.72621 13.4499 9.32618 13.8762C10.2261 14.5158 10.3387 17.1234 12.3861 15.8775C14.4335 14.6317 11.5094 14.1233 12.144 12.3185C12.7785 10.5132 14.8571 11.9156 15.0635 9.9384C15.2016 8.62026 13.6249 8.11581 10.3333 8.42507",
    stroke: "white",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8366 8.79102C17.4636 10.8628 16.6348 12.1138 17.3502 12.544C18.4233 13.1898 18.8785 12.2807 20.1883 12.544C21.4982 12.8073 21.2141 14.5827 20.5255 14.5827C19.837 14.5827 16.2692 14.1284 16.449 16.2103C16.6288 18.2921 18.7747 18.6003 18.7747 19.7635C18.7747 20.5388 18.2998 21.7255 17.3502 23.3239M7.4209 19.1427C7.70398 19.0181 7.98862 18.8971 8.27475 18.7797C9.87225 18.1346 11.0578 17.9825 11.8313 18.3233C13.1985 18.9267 12.6727 20.1452 13.1013 20.5941C13.5291 21.0431 14.5989 20.9127 14.5989 21.7665C14.5989 22.336 14.4076 22.9792 14.0249 23.696",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewImmigrant);
export default __webpack_public_path__ + "static/media/NewImmigrant.2efa21aa2e2b31060e1a8dd25ef1e16f.svg";
export { ForwardRef as ReactComponent };